import type { HandleImageUploadFn } from "@hubrise/react-components"

import useEditor from "./useEditor"
import useImageUpload from "./useImageUpload"

const useHandleImageUpload = (): HandleImageUploadFn => {
  const imageUpload = useImageUpload()
  const { catalog } = useEditor()

  return async (blob) => {
    try {
      const imageHrId = await imageUpload(blob, catalog.hrId)
      return { imageHrId }
    } catch (error) {
      return { error: error as string }
    }
  }
}

export default useHandleImageUpload
